import '../helpers/helpers';

import * as slickSliders from '../functions/slickSliders';
// import * as googleMap from '../functions/googleMap';
import * as scrollEvent from '../eventHandlers/scrollEvent';

import * as Lazy from 'jquery-lazy';

document.addEventListener('DOMContentLoaded', function(){

	function toggleOverlay() {
		var overlay = $('.overlay');

		if(overlay.hasClass('open')) {
			overlay.removeClass('open');
			overlay.addClass('close');

			setTimeout(function(){
				overlay.removeClass('close');
			}, 250);
		} else if(!overlay.hasClass('close')) {
			overlay.addClass('open');
		}
	}

	var $lightgallery = $('.lightgallery'),
		$map = document.getElementById('map'),
		$mainSlider = document.querySelectorAll('.main-slider');

	if($mainSlider){
		slickSliders.init();
	}

	scrollEvent.init();

	$('.trigger-btn, .overlay-close').on('click', toggleOverlay);

	if($lightgallery.length) {
		$("#gallery").lightGallery({
			selector: '.lightgallery' 
		});

		// Thumbnails
		// $(".small-gallery").lightGallery({
		// 	thumbnail:true
		// });
	}

	$("img[data-src], div[data-src], figure[data-src], a[data-src]").Lazy({
		effect: "fadeIn",
        effectTime: 200,
        attribute: 'data-lazy',
        enableThrottle: true,
        throttle: 250,
        threshold: 200
	});

	$('#overlay-menu').find('.menu-item-has-children a').on('click', function(e){
		if($(this).parent().hasClass('no-click')) {
			e.preventDefault();
			e.stopPropagation();
		}

		$(this).parent().toggleClass('active');

		$(this).parent().find('.sub-menu').first().slideToggle();
	});

	// if($map) {
	// 	googleMap.init();
	// }

	$('.btn--contact').on('click', function(){
		$('.popup-hld--contact').addClass('js-show');
	});

	$('.close-btn, .popup-blank').on('click', function(){
		$('.popup-hld').removeClass('js-show');
	});

	$('.testdrive').on('click', function(e){
		e.stopPropagation();
		e.preventDefault();

		$('.popup-hld--testdrive').addClass('js-show');

		if($('body').hasClass('home')){
			var title = $(this).parent().find('select').val();

			$('.popup-hld--testdrive').find('.page-title').val(title);
		} else if($('.content-hld--single').length){
			var title = $('.content-hld--single').find('h1').text();
			
			$('.popup-hld--testdrive').find('.page-title').val(title);
		}
	});

	$('.service').on('click', function(e){
		e.stopPropagation();
		e.preventDefault();

		$('.popup-hld--service').addClass('js-show');

		if($('body').hasClass('home')){
			var title = $(this).parent().find('select').val();

			$('.popup-hld--service').find('.page-title').val(title);
		} 
	});

	$('.finance').on('click', function(e){
		e.stopPropagation();
		e.preventDefault();
		
		$('.popup-hld--finance').addClass('js-show');

		if($('body').hasClass('home')){
			var title = $(this).parent().find('select').val();

			$('.popup-hld--finance').find('.page-title').val(title);
		} else {
			var title = $('body').find('h1').text();
			
			$('.popup-hld--finance').find('.page-title').val(title);
		}
	});

	$('.filter-hld ul').find('a').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();

		var $this = $(this),
		filterEl = $this.attr('data-filter');

		$('.filter-hld ul a').removeClass('active');
		$this.addClass('active');
		$('.row--offer-items').addClass('loading');

		if($this.attr('data-filter') !== undefined ){
			$('.offer-item-hld').stop(0,0).fadeOut(function(){
				setTimeout(function(){
					$('.offer-item-hld[data-offer="'+filterEl+'"]').attr('data-offer', filterEl).stop(0,0).fadeIn();
				}, 100);
			});

			setTimeout(function(){
				$('.row--offer-items').removeClass('loading');
			}, 500);
		} else {
			$('.offer-item-hld').fadeIn();
			
			setTimeout(function(){
				$('.row--offer-items').removeClass('loading');
			}, 500);
		}
	});

	$('body').on('click', '.scroll-to', function() {
		var topPos = 0;
		if($(this).attr("id") === "scroll-down") { topPos = $("#page-body").offset().top; }
		if($(this).hasClass("scroll-to")) { 
			var href = $(this).attr('href');
			var target = $(this).attr('data-target');
			if (href.charAt(0) === '#') { target = href; }
			topPos = $(target).offset().top - 50;
		}
		$('html,body').animate({ scrollTop: topPos}, 1000);
		return false;
	});
});

// $(window).on('load', function() {
	
// 	if(!Modernizr.csspointerevents && !Modernizr.touchevents) {
// 		var mySkrollr = skrollr.init({
// 			edgeStrategy: 'set',
// 			smoothScrolling: false,
// 			forceHeight: false
// 		});
// 	}

// });